import { forwardRef } from 'react';
import { cn } from '../../lib/cn';

// Wspólne klasy pól formularza. Wcześniej ten sam ~140-znakowy string
// ("mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm
// focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm")
// był wklejony w około 30 miejscach — a mimo to wygląd i tak trzeba było
// potem korygować warstwą !important w index.css, bo część wystąpień się różniła.
export const controlClasses = (invalid, className) =>
  cn(
    'block w-full rounded-md border bg-surface px-3 text-sm text-content transition-colors',
    'placeholder:text-subtle',
    'focus:outline-none focus:ring-2 focus:ring-accent/30',
    'disabled:cursor-not-allowed disabled:bg-elevated disabled:text-muted',
    invalid
      ? 'border-danger-line focus:border-danger focus:ring-danger/25'
      : 'border-line hover:border-line-strong focus:border-accent',
    className
  );

export const Input = forwardRef(function Input({ invalid, className, ...props }, ref) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={controlClasses(invalid, cn('h-9', className))}
      {...props}
    />
  );
});

export const Textarea = forwardRef(function Textarea({ invalid, className, rows = 3, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={controlClasses(invalid, cn('resize-y py-2', className))}
      {...props}
    />
  );
});

export const Select = forwardRef(function Select({ invalid, className, children, ...props }, ref) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={controlClasses(invalid, cn('h-9 cursor-pointer pr-8', className))}
      {...props}
    >
      {children}
    </select>
  );
});

export const Checkbox = forwardRef(function Checkbox({ label, className, id, ...props }, ref) {
  return (
    <label
      htmlFor={id}
      className={cn('inline-flex cursor-pointer select-none items-center gap-2 text-sm text-content', className)}
    >
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="h-4 w-4 cursor-pointer rounded border-line-strong bg-surface text-accent focus:ring-2 focus:ring-accent/30 focus:ring-offset-0"
        {...props}
      />
      {label}
    </label>
  );
});

export default Input;
